import { Component, OnInit, Inject } from '@angular/core';
import { DataService } from '../../utils/data.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { generalService } from '../../services/general.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
@Component({
  selector: 'my-factura-descargar',
  styles: [],
  templateUrl: './factura-descargar.component.html',
  providers: [generalService]
})
export class FacturaDescargarComponent implements OnInit {

  mensaje: string = '';
  confirm: boolean;
  constructor(
    public dataService: DataService,
    public dialogRef: MatDialogRef<FacturaDescargarComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
   
  }

  ngOnInit() {
   
  }


  cerrarModal() {
    this.dialogRef.close(false);
  }

  aceptar() {
    this.dialogRef.close(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/factura/consultar-eliminar/factura-descargar.component.ts